module.exports = __webpack_public_path__ + "static/img/6.5f11258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/6.png
// module id = b0ML
// module chunks = 0